import React from 'react'
import CompanyProfile from '../components/Company-Profile/company-profile'

const CompanyProfilePage: React.FC = () => {
    return (
        <div className="min-h-screen p-5">
            <div className="mx-auto max-w-7xl">
                <CompanyProfile />
            </div>
        </div>
    )
}

export default CompanyProfilePage